import { IxGridNoRows } from './components/IxGridNoRows.js';

window.customElements.define('ix-grid-no-rows', IxGridNoRows);
